<template>
  <v-app light>
    <Loading />
    <main>
      <v-container fill-height>
        <v-layout row wrap align-center>
          <v-flex sm8 lg4 offset-sm2 offset-lg4 class="text-xs-center">
            <div class="mb-5">
              <img src="static/logo.png" style="max-width: 40%;">
            </div>
            <form v-on:submit.prevent="onSubmit" class="mt-4">
              <v-flex xs12>
                <v-text-field
                  v-model.trim="form.fields.email"
                  label="E-mail"
                  v-validate="'required|email'"
                  name="email"
                  data-vv-as="e-mail"
                  :error-messages="errors.has('email') ? errors.first('email') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.trim="form.fields.password"
                  label="Senha"
                  v-validate="'required|min:6'"
                  name="password"
                  type="password"
                  data-vv-as="senha"
                  :error-messages="errors.has('password') ? errors.first('password') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
                <v-btn
                  type="submit"
                  outline
                  block
                  large
                  class="secondary secondary--text ma-0"
                  :disabled="isFormInvalid"
                >
                  Entrar
                </v-btn>
              </v-flex>
            </form>
            <v-flex xs12 class="mt-4">
              <v-dialog v-model="dialogRecuperarSenha" fullscreen transition="dialog-bottom-transition" :overlay="false">
                <p slot="activator" class="primary--text">Esqueci a senha</p>
                <v-card>
                  <v-toolbar dark class="primary">
                    <v-btn icon @click.native="dialogRecuperarSenha = false" dark>
                      <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Esqueci a senha</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="mt-4 px-4 text-xs-center">
                    <p class="secondary--text mb-4">Uma mensagem será enviada para o e-mail cadastrado.</p>
                    <form v-on:submit.prevent="onSubmitRecuperarSenha" class="mt-4">
                      <v-text-field
                        v-model="form.fields.email"
                        label="E-mail"
                        v-validate="'required|email'"
                        name="email"
                        data-vv-as="e-mail"
                        :error-messages="errors.has('email') ? errors.first('email') : []"
                      >
                      </v-text-field>
                      <v-btn
                        type="submit"
                        outline
                        large
                        class="secondary secondary--text"
                      >
                        Recuperar senha
                      </v-btn>
                    </form>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </main>
    <Snackbar v-for="(item, i) in snackbar" :key="i"></Snackbar>
  </v-app>
</template>

<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import Loading from '@/components/Utils/Loading'
  import Snackbar from '@/components/Utils/Snackbar'

  export default {
    components: {
      Loading,
      Snackbar
    },
    data () {
      return {
        dialogRecuperarSenha: false,
        form: {
          fields: {
            email: '',
            password: ''
          }
        }
      }
    },
    computed: {
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      },
      snackbar () {
        return this.$store.getters['utils/snackbar']
      }
    },
    methods: {
      onSubmitRecuperarSenha () {
        this.$store.dispatch('utils/showLoading')
        axios.post(`${apiURL}/password-forgot`, { email: this.form.fields.email }).then((response) => {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'E-mail enviado com sucesso.',
            type: 'success'
          })
          this.dialogRecuperarSenha = false
          this.$store.dispatch('utils/hideLoading')
        }, () => {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'E-mail não encontrado.',
            type: 'error'
          })
          this.$store.dispatch('utils/hideLoading')
        })
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')
        this.$auth.login({
          data: {
            email: this.form.fields.email,
            password: this.form.fields.password
          },
          success: function () {
            this.$store.dispatch('utils/hideLoading')

            // Enable push
            Vue.cordova.on('deviceready', () => {
              window.plugins.OneSignal.setSubscription(true)
              window.plugins.OneSignal.sendTag('user_id', this.$auth.user().id)
            })
          },
          error: function (error) {
            let errorText = ''
            let errorType = 'error'
            if (error.response.status === 401) {
              errorText = 'E-mail ou senha inválidos. Tente novamente.'
            } else if (error.response.status === 409) {
              errorText = 'Seu usuário encontra-se inativo. Solicite a um administrador para ativa-lo.'
              errorType = 'info'
            } else {
              errorText = 'Servidor indisponível. Tente novamente mais tarde.'
            }

            this.$store.dispatch('utils/showSnackbar', {
              text: errorText,
              type: errorType
            })
            this.$store.dispatch('utils/hideLoading')
          },
          rememberMe: true,
          fetchUser: true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?0c6cef7c